import Link from "next/link";
import Image from "next/image";
import { DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

const SearchItem = ({ data, onOpenChange }) => {
  const image = data.image;
  return (
    <li className="list-none mb-2">
      <Link 
        href={data.url} 
        className="flex items-center w-full justify-between"
        onClick={() => onOpenChange(false)}
      >
        <div className={`${image ? 'w-[60%] md:w-[70%] lg:w-[80%]': "w-full"}`}>
          <p
            className="
            text-sm md:text-base desktop:text-lg
            text-font-darkBlue
            "
          >
            {data.title}
          </p>
          <p
            className="
            text-xs md:text-sm xl:text-[14px] desktop:text-base  
            text-font-primaryMuted
            mr-2 whitespace-pre-wrap	           
            "
          >
            {data.description}
          </p>
        </div>
        {image && image.src && (
          <Image
            unoptimized
            src={image.src}
            height={80}
            width={80}
            alt={data.title}
            className="inline"
          />
        )}
      </Link>
      <DropdownMenuSeparator />
    </li>
  );
};

export default SearchItem;
